// @flow
import recaptcha from 'utils/recaptcha';
import * as React from 'react';
import styled from 'styled-components';
import { configValue } from 'utils/config';

const StyledRecaptchaInput = styled.div`
  height: 78px;
`;

export default class RecaptchaInput extends React.Component<{
  onChange: Function
}> {
  setupRecaptcha = (el: ?Element) => {
    if (!el) return;

    recaptcha().then(r => {
      r.render(el, {
        sitekey: configValue('google', 'recaptcha', 'siteKey'),
        callback: response => {
          this.props.onChange(response);
        },
        'expired-callback': () => {
          // Remove old value because it't no longer valid
          this.props.onChange();
        }
      });
    });
  };

  render() {
    return <StyledRecaptchaInput ref={this.setupRecaptcha} />;
  }
}
